import Cookies from 'react-cookies';
import {useParams, Navigate} from 'react-router-dom';
import {useEffect} from 'react';

export default () => {
    const {bonusToken} = useParams();

    useEffect(() => {
        window.localStorage.setItem('bonusToken', bonusToken);
    }, [bonusToken]);

    return (
        <Navigate to={'/'} />
    )
}